import { render, staticRenderFns } from "./MaxBot.vue?vue&type=template&id=527f83b0&"
import script from "./MaxBot.vue?vue&type=script&lang=js&"
export * from "./MaxBot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports